import { useTranslation } from "react-i18next"
import { useEquityIssuesHeatmap } from "../../../hooks/queries/useEquityIssuesHeatmap"
import { equityHeatMap } from "../utils"

export const useKnowledgeBaseMessage = (countryCode: string, equityType: string) => {
  const { t } = useTranslation("equity/EquityGrantPage")
  const { loading, results } = useEquityIssuesHeatmap({ countryCode })
  const [countryInfo] = results
  const heatmap = equityHeatMap(countryInfo, equityType) || 0
  const anchor = t(`${equityType}.anchor`) // This includes the # to cover SOP properly
  const url = `https://app.oysterhr.com/equity-assessment/${countryCode}${anchor}`
  return {
    t,
    loading,
    heatmap,
    url,
    results,
  }
}

export const messageTranslationKey = (heatmap: number) => {
  return ["none", "preferred", "possible", "discouraged"][heatmap]
}
